import accessToken from "../../things/AccessToken";

import user from "../../user";

class AuthStatus
{
    static GUEST             = 'guest' ;
    static NEED_ACCESS_TOKEN = "needAccessToken" ;
    static NEED_USER         = "needUser" ;
    static CONNECTED         = 'connected' ;

    static check()
    {
        if( !accessToken.stored )
        {
            return AuthStatus.NEED_ACCESS_TOKEN ;
        }
        else if ( !user.stored )
        {
            return AuthStatus.NEED_USER ;
        }
        else if( accessToken.stored && user.stored )
        {
            return AuthStatus.CONNECTED ;
        }
        else
        {
            return AuthStatus.GUEST ;
        }
    }
}

export default AuthStatus ;


// WEBPACK FOOTER //
// ./src/app/net/auth/AuthStatus.js